<app-base-template>
  <h1 [innerHTML]="'pages.connected.title' | translate"></h1>
  <h2 [innerHTML]="'pages.connected.subtitle' | translate"></h2>
  <div class="stepper-list">
    <app-stepper-item icon="video" [completionPercent]="50" [stepIndex]="1" dividerSize="xl"
      content="pages.connected.steps.select_video" />
    <app-stepper-item icon="go" [completionPercent]="100" [stepIndex]="2" [isLast]="true"
      content="pages.connected.steps.exercize" />
  </div>
</app-base-template>